import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Dropdown,
  Modal,
  Select,
  Table,
  Textarea,
  TextInput,
  Tooltip,
} from "flowbite-react";
import { toast } from "react-toastify";

import {
  FaEdit,
  FaEllipsisV,
  FaExternalLinkAlt,
  FaLink,
  FaMailBulk,
  FaTrash,
  FaUser,
} from "react-icons/fa";
import { AuthContext } from "../../../Contexts/AuthProvider/AuthProvider";
import ReactPaginate from "react-paginate";
import Loader from "../../../Shared/Loader/Loader";
import { Link } from "react-router-dom";

const AllQnA = () => {
  const { user } = useContext(AuthContext);

  const [qna, setQnA] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [refetch, setRefetch] = useState(false);

  // console.log(editData?._id)

  useEffect(() => {
    fetch("https://shadin-organic-server.vercel.app/all-qna")
      .then((res) => res.json())
      .then((data) => {
        setQnA(data);
      });
  }, [refetch]);

  const itemsPerPage = 8;

  const endOffset = itemOffset + itemsPerPage;

  const currentItems = qna?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(qna.length / itemsPerPage);
  console.log(currentItems);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % qna.length;
    // console.log(
    //     `User requested page number ${event.selected}, which is offset ${newOffset}`
    // );
    setItemOffset(newOffset);
  };
  return (
    <div className="flex w-full">
      <div className="mx-auto flex-grow overflow-x-auto">
        {qna ? (
          <h2 className="title uppercase p-10 text-center mb-10 bg-secondary text-white text-2xl font-semibold">
            All QnA{" "}
          </h2>
        ) : (
          <Loader></Loader>
        )}
        {qna?.length ? (
          <p> </p>
        ) : (
          <p className="text-2xl mt-16 text-center text-orange-500 ">
            You have No QnA
          </p>
        )}

        {currentItems
          ?.filter((item) => item.product)
          .map((comment, i) => (
            <div className="grid lg:grid-cols-11 grid-cols-1 gap-2 bg-gray-50 my-4 py-4">
              <div className="lg:col-span-2  col-span-1 ml-2">
                <div className="flex items-center gap-2">
                  <p className="mx-2">{i + 1}</p>
                  <img
                    src={comment?.product?.primary_img}
                    className="h-20 w-20 rounded ring-1 ring-blue"
                    alt=""
                  />
                  <div className="text-sm">
                    <p>{comment?.product?.product_name}</p>
                    <p>{comment?.product?.category}</p>
                    <p>{comment?.product?.price}৳ </p>
                  </div>
                </div>
              </div>
              <div className="lg:col-span-7 text-sm col-span-1 mx-2 break-words">
                <p className="m-2">
                  Q:{" "}
                  {comment?.question.length > 100
                    ? comment?.question.slice(0, 100) + "..."
                    : comment?.question}
                </p>
                <p className="mx-2">A: {comment?.reply}</p>
              </div>
              <div className="lg:col-span-2 col-span-1">
                <Link
                  className="text-blue-400 truncate ... "
                  to={`/singleproduct/${comment?.product_id}`}
                >
                  <div className="mt-4">
                    <Button size="xs" outline={true}>
                      <FaExternalLinkAlt className="mr-2" /> Go to Product
                    </Button>{" "}
                  </div>
                </Link>
              </div>
            </div>
          ))}
        <div className="pagination my-6">
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="<"
            renderOnZeroPageCount={null}
            containerClassName="pagination-menu"
          />
        </div>
      </div>
    </div>
  );
};

export default AllQnA;
